import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useLocation } from 'react-router';
import { api, errorMessage } from '../api/client';
import { useAuth } from '../store/auth';
import { Alert, Button, Modal } from './ui';

/** Grava o aceite (ou a recusa) dos avisos por SMS e atualiza o usuário da sessão. */
export function useSetSmsAlerts() {
  return useMutation({
    mutationFn: (enabled: boolean) => api.call('setSmsAlerts', { body: { enabled } }),
    onSuccess: (user) => {
      const { token, setSession } = useAuth.getState();
      if (token) setSession(token, user);
    },
  });
}

/**
 * Pergunta uma vez se o jogador quer avisos importantes no celular (lembrete de turno sem ordens,
 * governo interino). Fechar sem responder só esconde até o próximo acesso.
 */
export function SmsAlertsPrompt() {
  const user = useAuth((s) => s.user);
  const location = useLocation();
  const [dismissed, setDismissed] = useState(false);
  const save = useSetSmsAlerts();
  const open =
    !dismissed &&
    !!user?.phoneVerified &&
    user.smsAlerts === null &&
    location.pathname !== '/confirmar-celular';
  return (
    <Modal open={open} onOpenChange={(o) => !o && setDismissed(true)} title="Avisos no celular">
      <div className="flex flex-col gap-3 font-mono text-[11px] leading-relaxed">
        <p>Quer receber avisos importantes por SMS?</p>
        <ul className="list-disc pl-4 text-muted">
          <li>Lembrete 3h antes da virada do turno, se você ainda não deu ordens.</li>
          <li>Aviso antes do seu governo ficar interino por falta de acesso.</li>
        </ul>
        <p className="text-muted">Você pode mudar isso depois na tela Conta.</p>
        {save.error && <Alert>{errorMessage(save.error)}</Alert>}
        <div className="flex justify-end gap-2">
          <Button onClick={() => save.mutate(false)} disabled={save.isPending}>
            Agora não
          </Button>
          <Button variant="primary" onClick={() => save.mutate(true)} disabled={save.isPending}>
            Quero receber
          </Button>
        </div>
      </div>
    </Modal>
  );
}
